// Generated by genversion.
export const version = '1.27.0';
